"use client";

import { cn } from "@shared/lib/cn";
import type * as React from "react";

function Separator({
  className,
  orientation = "horizontal",
  role = "separator",
  ...props
}: React.ComponentProps<"div"> & {
  orientation?: "horizontal" | "vertical";
  /** separator inherits the app's default border color, presentation is more subtle */
  role?: "separator" | "presentation";
}) {
  return (
    // biome-ignore lint/a11y/useAriaPropsSupportedByRole: aria-orientation is valid for role=separator; Biome can't statically resolve the dynamic role prop
    <div
      data-slot="separator"
      role={role}
      aria-orientation={role === "separator" ? orientation : undefined}
      data-orientation={orientation}
      className={cn(
        "bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
